import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { User } from 'app/auth/models';

@Injectable({ providedIn: 'root' })
export class TemplateService {
  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  public plans;
  public rows;

  getAlltemplates(type): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._http.get(`${environment.apiUrl}/template/${type}`).subscribe((response: any) => {
        resolve(response);
        return response;
      }, reject);
    });
  }

  getTemplatesModels(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._http.get(`${environment.apiUrl}/template/models/`).subscribe((response: any) => {
        resolve(response);
        return response;
      }, reject);
    });
  }
  

  getTemplate(id): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._http.get(`${environment.apiUrl}/template/${id}/info`).subscribe((response: any) => {
        resolve(response);
        return response;
      }, reject);
    });
  }

  
  getTemplateEdit(id): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._http.get(`${environment.apiUrl}/template/${id}/edit`).subscribe((response: any) => {
        resolve(response);
        return response;
      }, reject);
    });
  }

  createTemplate(data): Promise<any[]> {
    return new Promise((resolve, reject) => {      
      this._http
        .post(`${environment.apiUrl}/template`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  updateTemplate(data): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._http
        .patch(`${environment.apiUrl}/template/${data.id}/update`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  useTemplate(type, id): Promise<any[]> {
    return new Promise((resolve, reject) => {      
      this._http
        .post(`${environment.apiUrl}/template/${id}/add`, {"type": type})
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

}